var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.137,
    height: 34.569,
    viewBox: "0 0 27.137 34.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555",
    transform: "translate(-539 -4705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10837",
    "data-name": "Rectangle 10837",
    width: 27.137,
    height: 6.385,
    transform: "translate(539 4724.404)",
    fill: "#ef863a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10838",
    "data-name": "Rectangle 10838",
    width: 27.137,
    height: 6.385,
    transform: "translate(539 4733.184)",
    fill: "#ef863a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M13.5,0,27,16H0Z",
    transform: "translate(539 4705)",
    fill: "#ef863a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSymbol);
export default __webpack_public_path__ + "static/media/Upload Symbol.f5a15de313f29f6c174a130e79b82484.svg";
export { ForwardRef as ReactComponent };